module.exports = __webpack_public_path__ + "img/洗涤台.517b6041.jpg";